import * as R from 'ramda';

import { Icon, IconButton } from '@atom/mui';
import { ArrowDropDownIcon, ArrowRightIcon, FolderIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { WorkTemplateFolderTree } from '@atom/types/workTemplate';

import classes from './workTypeFolderTree.module.css';

const PADDING_OFFSET = 2;

const styles = {
  arrowStyle: {
    fontSize: '24px',
    margin: 0,
    color: colors.neutral.dim,
  },
  iconStyle: {
    fontSize: '24px',
    margin: 0,
    color: colors.neutral.gray,
  },
  indentation: {
    paddingLeft: '3rem',
  },
  blankStyle: {
    boxSizing: 'border-box',
    padding: '24px',
  },
};

export interface Props {
  folder: WorkTemplateFolderTree;
  indentation: number;
  open: Set<string>;
  toggleOpen: (id: string) => void;
  selectWorkTemplateFolder: (
    workTemplateFolder: WorkTemplateFolderTree,
  ) => void;
}

const WorkTypeFolderTreeRow = ({
  folder,
  indentation,
  open,
  toggleOpen,
  selectWorkTemplateFolder,
}: Props) => {
  const expanded = open.has(folder.id);

  const arrowDirection = expanded ? ArrowDropDownIcon : ArrowRightIcon;

  const expandClick = async () => {
    if (R.isEmpty(folder.children)) {
      selectWorkTemplateFolder(folder);
    }

    toggleOpen(folder.id);
  };

  const renderExpandedArrow = !R.isEmpty(folder.children);

  const leftIcon = (
    <>
      {renderExpandedArrow && (
        <IconButton>
          <Icon style={styles.arrowStyle} icon={arrowDirection} />
        </IconButton>
      )}
      <Icon style={styles.iconStyle} icon={FolderIcon} />
    </>
  );

  const containerStyle = {
    paddingLeft: `calc(2rem + ${PADDING_OFFSET * indentation}rem)`,
  };

  return (
    <>
      <div
        className={classes.folderRow}
        style={containerStyle}
        onClick={expandClick}
      >
        <div
          className={classes.folderNameContainer}
          style={renderExpandedArrow ? {} : styles.indentation}
        >
          {leftIcon}
          <div className={classes.rowNameContainer}>
            <div className={classes.rowTitle}>{folder.name}</div>
          </div>
        </div>
      </div>
      {expanded ? (
        folder.children.map((child: WorkTemplateFolderTree) => (
          <WorkTypeFolderTreeRow
            key={child.id}
            folder={child}
            indentation={indentation + 1}
            open={open}
            toggleOpen={toggleOpen}
            selectWorkTemplateFolder={selectWorkTemplateFolder}
          />
        ))
      ) : (
        <div />
      )}
    </>
  );
};

export default WorkTypeFolderTreeRow;
